/**
 * Intake workflow tab configuration.
 *
 * Tab order: extraction -> eligibility -> prior_auth -> ready_to_call -> scheduling -> push_to_emr
 *
 * Note: Tabs can be completed in any order. There is no enforced prerequisite
 * ordering - users may skip ahead or complete tabs out of sequence as needed.
 */

export type IntakeTabKey =
  | 'extraction'
  | 'eligibility'
  | 'prior_auth'
  | 'ready_to_call'
  | 'scheduling'
  | 'push_to_emr';

export interface EnabledTabs {
  extraction?: boolean;
  eligibility?: boolean;
  prior_auth?: boolean;
  ready_to_call?: boolean;
  scheduling?: boolean;
  push_to_emr?: boolean;
}

/**
 * Default enabled tabs configuration when feature flags are not available.
 * Used as default props in components that accept enabledTabs.
 */
export const DEFAULT_ENABLED_TABS: Required<EnabledTabs> = {
  extraction: true,
  eligibility: true,
  prior_auth: true,
  ready_to_call: true,
  scheduling: true,
  push_to_emr: true,
};
